export function FlexibleSavingsChart() {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-xl font-bold text-foreground mb-6">Flexible Savings Insights</h2>
      {/* Customize your flexible savings chart here */}
      <div>Chart for Flexible Savings</div>
    </div>
  )
}
